import {app} from "../../config/constants"
import * as imagesActions from './actions'
import {store} from "../../reducers"

export const loadImages = (dimensions, height) => {

	let i = 0;

	for ( const dimension of dimensions ) {
		const ref = app.database().ref('/cams/images/' + dimension.width + 'x' + dimension.height);
		let sort = 0;

		ref.orderByKey().on('value', (images) => {
			let j = 0;

			new Promise( ( resolve, reject ) => {
				let retImages = [];

				images.forEach( ( image ) => {
					retImages.push({
						path: image.val().path,
						thumbPath: image.val().thumb,
						key: image.key,
						sort: ++sort,
					});

					if ( ++j === images.numChildren() ) {
						resolve( retImages );
					}
				});
			}).then( ( images ) => {
				store.dispatch(imagesActions.addImages(images));
			});
		});

		ref.on('child_changed', ( image ) => {
			store.dispatch(imagesActions.updateImage({
				path: image.val().path,
				thumbPath: image.val().thumb,
				key: image.key
			}))
		})
	}
};

export const resetImages = () => {
	store.dispatch(imagesActions.resetImages());
	return Promise.resolve();
};

export const addTempImage = ( image ) => {
	store.dispatch(imagesActions.addTempImage(image));
};

export const removeTempImage = ( image ) => {
	store.dispatch(imagesActions.removeTempImage(image));
};

export const updateTempImage = ( image ) => {
	store.dispatch(imagesActions.updateTempImage(image));
};


// WEBPACK FOOTER //
// ./src/api/images/index.js